import React, { useState } from "react";

import { Button, UncontrolledPopover, PopoverBody } from "reactstrap";
import AudioRecorder from "../../../../components/AudioRecorder";
// import AudioRecorder from "../../../../components/AudioRecorder";
interface EndButtonsProps {
  onSubmit: () => void;
  onAudioRecorded: (base64: string) => void;
  disabled: boolean;
}
const EndButtons = ({ onSubmit, disabled, onAudioRecorded }: EndButtonsProps) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="chat-input-links ms-2 gap-md-1">
      <div className="links-list-item d-none d-sm-block">
        <Button
          color="none"
          type="button"
          className="btn btn-link text-decoration-none btn-lg waves-effect"
          id="audio-btn"
          onClick={() => setOpen(!open)}
        >
          <i className="bx bx-microphone align-middle"></i>
        </Button>
      </div>
      {/* <UncontrolledPopover transition={{ timeout: 1 }}
        delay={0} trigger="focus" placement="top" target="audio-btn">
        <PopoverBody>
          <div className="loader-line">
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
          </div>
        </PopoverBody>
      </UncontrolledPopover> */}

      <UncontrolledPopover
        isOpen={open}
        toggle={() => setOpen(!open)}
        placement="top"
        target="audio-btn"
        trigger="legacy"
      >
        <PopoverBody style={{ minWidth: 260 }}>
          <AudioRecorder
            onSend={(base64) => {
              onAudioRecorded(base64);
              setOpen(false);
            }}
            onCancel={() => setOpen(false)}
          />
        </PopoverBody>
      </UncontrolledPopover>

      <div className="links-list-item">
        <Button
          color="primary"
          type="submit"
          // disabled={disabled}
          className="btn btn-primary btn-lg chat-send waves-effect waves-light"
        >
          <i className="bx bxs-send align-middle"></i>
        </Button>
      </div>
    </div>
  );
};

export default EndButtons;
